 /**
  * Error Codes
  * 
  * Standardized error codes returned by edge functions
  * and used by frontend guards for conditional rendering.
  */
 
 // Authentication errors (401)
 export const AUTH_ERROR_CODES = {
   NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
   INVALID_TOKEN: 'INVALID_TOKEN',
 } as const;
 
 // Authorization errors (403)
 export const ACCESS_ERROR_CODES = {
   // Email verification
   EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
   
   // Account status
   ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
   ACCOUNT_DELETED_REQUESTED: 'ACCOUNT_DELETED_REQUESTED',
   
   // Subscription
   NOT_SUBSCRIBER: 'NOT_SUBSCRIBER',
   SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
   
   // Role-based
   NOT_ADMIN: 'NOT_ADMIN',
   NOT_DEALER_USER: 'NOT_DEALER_USER',
   NOT_DEALER_ADMIN: 'NOT_DEALER_ADMIN',
   NOT_INTERNAL_ADMIN: 'NOT_INTERNAL_ADMIN',
   
   // Dealer org status
   ORG_NOT_APPROVED: 'ORG_NOT_APPROVED',
   ORG_SUSPENDED: 'ORG_SUSPENDED',
   MEMBER_INACTIVE: 'MEMBER_INACTIVE',
 } as const;
 
 // Combined error codes type
 export type AuthErrorCode = typeof AUTH_ERROR_CODES[keyof typeof AUTH_ERROR_CODES];
 export type AccessErrorCode = typeof ACCESS_ERROR_CODES[keyof typeof ACCESS_ERROR_CODES];
 export type ErrorCode = AuthErrorCode | AccessErrorCode;
 
 /**
  * Map error code to user-friendly message
  */
 export function getErrorMessage(code: ErrorCode): string {
   const messages: Record<ErrorCode, string> = {
     NOT_AUTHENTICATED: 'Please sign in to continue',
     INVALID_TOKEN: 'Your session has expired. Please sign in again.',
     EMAIL_NOT_VERIFIED: 'Please verify your email address before continuing',
     ACCOUNT_SUSPENDED: 'Your account has been suspended. Please contact support.',
     ACCOUNT_DELETED_REQUESTED: 'Your account is scheduled for deletion. Contact support to cancel.',
     NOT_SUBSCRIBER: 'Active subscription required to access this resource',
     SUBSCRIPTION_EXPIRED: 'Your subscription has expired. Please renew to continue.',
     NOT_ADMIN: 'Admin access required',
     NOT_DEALER_USER: 'Dealer account required',
     NOT_DEALER_ADMIN: 'Dealer admin access required',
     NOT_INTERNAL_ADMIN: 'Internal admin access required',
     ORG_NOT_APPROVED: 'Your dealership is pending approval',
     ORG_SUSPENDED: 'Your dealership has been suspended',
     MEMBER_INACTIVE: 'Your account has been deactivated by your dealership admin',
   };
   return messages[code] || 'Access denied';
 }